import classNames from 'classnames';
import produce from 'immer';
import React, { useEffect, useRef, useState } from 'react';
import Menu from '~/components/menu';
import { useUser } from '~/providers/user';
import { useWorkspaceFolder } from '~/routes/projects_workspace/provider';
import Permissions from '~/settings/permissions';
export var ComparisonStatus;
(function (ComparisonStatus) {
    ComparisonStatus["InProgress"] = "In Progress";
    ComparisonStatus["Completed"] = "Completed";
    ComparisonStatus["Archived"] = "Archived";
})(ComparisonStatus || (ComparisonStatus = {}));
const StatusCell = (props) => {
    var _a;
    const [isExpanded, setIsExpanded] = useState(false);
    const ref = useRef(null);
    const { updateComparisonStatus, setComparisonDetails, comparisonDetails } = useWorkspaceFolder();
    const { hasPermission } = useUser();
    useEffect(() => {
        function handleClickOutside(event) {
            var _a;
            const target = event.target;
            if (isExpanded && ref && !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(target)) &&
                !((target === null || target === void 0 ? void 0 : target.classList.contains('menu-item')) || (target === null || target === void 0 ? void 0 : target.classList.contains('status')))) {
                setIsExpanded(!isExpanded);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, isExpanded]);
    if (!props.colDef) {
        return;
    }
    const documentComparisonId = props.data.documentComparisonId;
    const projectDocumentComparisonId = props.data.projectDocumentComparisonId;
    const isArchivedRow = props.data.isArchived;
    const statusValue = props.data.isArchived
        ? ComparisonStatus.Archived
        : (_a = props.data.status) !== null && _a !== void 0 ? _a : ComparisonStatus.InProgress;
    const isStatusUpdateAllowed = hasPermission(Permissions.UPDATE_COMPARISON_STATUS) &&
        !isArchivedRow;
    const classnames = classNames('status', {
        'status-inprogress': statusValue === ComparisonStatus.InProgress,
        'status-archived': isArchivedRow,
        'status-complete': statusValue === ComparisonStatus.Completed,
    });
    const getStatusHtml = (classNames, text) => (React.createElement("span", { className: classNames }, text));
    const menuItems = [
        {
            key: ComparisonStatus.InProgress,
            name: ComparisonStatus.InProgress,
            component: getStatusHtml('status status-inprogress', ComparisonStatus.InProgress),
        },
        {
            key: ComparisonStatus.Completed,
            name: ComparisonStatus.Completed,
            component: getStatusHtml('status status-complete', ComparisonStatus.Completed),
        },
    ];
    const onItemClick = (status) => {
        updateComparisonStatus(documentComparisonId, status);
        const newComparisons = produce(comparisonDetails, (draft) => {
            if (!(draft === null || draft === void 0 ? void 0 : draft.length))
                return [];
            const index = draft.findIndex((c) => c.projectDocumentComparisonId === projectDocumentComparisonId);
            if (index !== -1)
                draft[index].status = status;
        });
        setComparisonDetails(newComparisons);
    };
    return (React.createElement("span", { className: classNames({ 'status-cell': isStatusUpdateAllowed }), onClick: () => !isArchivedRow && setIsExpanded(!isExpanded), ref: ref },
        React.createElement("span", { className: classnames },
            React.createElement("span", { title: statusValue }, statusValue),
            isStatusUpdateAllowed && isExpanded &&
                React.createElement(Menu, { showMenu: isExpanded, setShowMenu: setIsExpanded, onMenuItemClick: onItemClick, menuItems: menuItems, targetRef: ref.current })),
        isStatusUpdateAllowed && React.createElement("span", { className: 'status-chevron' },
            React.createElement("span", { key: +isExpanded },
                React.createElement("i", { className: classNames('fa-solid', 'fa-xs', {
                        'fa-chevron-up': isExpanded,
                        'fa-chevron-down': !isExpanded,
                    }) })))));
};
export default StatusCell;
